'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadConfig = exports.getConfig = undefined;

var _factory = require('./factory');

var _makeDynamicDataLoade = (0, _factory.makeDynamicDataLoader)('config', function (set) {
  if (__SERVER__) {
    set(require('config').clientConfig);
  }
}),
    getConfig = _makeDynamicDataLoade.get,
    loadConfig = _makeDynamicDataLoade.load;

exports.getConfig = getConfig;
exports.loadConfig = loadConfig;